// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/BarlowSCK-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/BarlowSCK-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/BarlowSCK-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: Font-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
@font-face {
    font-family: Font-Regular;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
    font-family: Font-SemiBold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}

:root {
    --psblue: #183557; 
    --psblue-accent: #0F2A3D;
    --psyellow: #fbba00;
}

* {
    font-family: Font-Regular;
    cursor: default;
}


/*------------HEADER------------*/
.headerWrapper * {
    font-family: Font-SemiBold;
    font-weight: 600 !important;
}
/* .pell-content {
    overflow: hidden !important;
} */

.meetingId {
    font-size: 1.2rem;
}

/*-------------INNER-------------*/
.section-title {
    font-size: 1rem;
    font-family: Font-SemiBold;
}
.section-content {
    font-size: 1rem;
}

/*------------FOOTER-------------*/
.footerWrapper * {
    font-size: 0.8rem;
    font-family: Font-SemiBold;
}`, "",{"version":3,"sources":["webpack://./src/commonStyles/fontAndColors.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,+DAAyD;AAC7D;AACA;IACI,yBAAyB;IACzB,+DAA2D;AAC/D;AACA;IACI,0BAA0B;IAC1B,+DAA4D;AAChE;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;;AAGA,iCAAiC;AACjC;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;;GAEG;;AAEH;IACI,iBAAiB;AACrB;;AAEA,kCAAkC;AAClC;IACI,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;;AAEA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,0BAA0B;AAC9B","sourcesContent":["@font-face {\n    font-family: Font-Light;\n    src: url(../fonts/BarlowSCK-Light.otf) format(\"opentype\");\n}\n@font-face {\n    font-family: Font-Regular;\n    src: url(../fonts/BarlowSCK-Regular.otf) format(\"truetype\");\n}\n@font-face {\n    font-family: Font-SemiBold;\n    src: url(../fonts/BarlowSCK-SemiBold.otf) format(\"opentype\");\n}\n\n:root {\n    --psblue: #183557; \n    --psblue-accent: #0F2A3D;\n    --psyellow: #fbba00;\n}\n\n* {\n    font-family: Font-Regular;\n    cursor: default;\n}\n\n\n/*------------HEADER------------*/\n.headerWrapper * {\n    font-family: Font-SemiBold;\n    font-weight: 600 !important;\n}\n/* .pell-content {\n    overflow: hidden !important;\n} */\n\n.meetingId {\n    font-size: 1.2rem;\n}\n\n/*-------------INNER-------------*/\n.section-title {\n    font-size: 1rem;\n    font-family: Font-SemiBold;\n}\n.section-content {\n    font-size: 1rem;\n}\n\n/*------------FOOTER-------------*/\n.footerWrapper * {\n    font-size: 0.8rem;\n    font-family: Font-SemiBold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
